const secondUrl = '/sitir-chipmunk-service'
const secondAuth = '/sitir-auth-service'

const apiConfig = {
  oauth: {
    // token刷新
    TOKEN: secondAuth + '/oauth/token',
  },
  idempotent: {
    // 幂等
    CREATE: secondUrl + '/chipmunk/idempotent/create',
  },
}

const env = {
  // test: 'http://nipponia.andeancat.test-plat-2.ant.act.sitejiu.local/nipponia-service',
  // test: 'http://gateway.dev.plat1.ant.magicsmithy.sitir.net/nipponia-service'
  // test: 'http://gateway.dev.plat5.ant.magicsmithy.sitir.net/nipponia-service'
  // test: 'http://nipponia.andeancat.dev-plat-8.ant.ms.sitejiu.local/nipponia-service'
  // test: 'http://nipponia.andeancat.pro-plat-3.ant.ac.sitejiu.local/nipponia-service'
  test: 'http://java.mlx',
  // test: 'nipponia-service'
}

export const testUrl = env.test

export default apiConfig
